import View from '@shared/components/layout-default/layout-default-router-view';
import { is_not_auth } from '@app/plugins/vue-router/middleware/auth.js';
import Dashboard from '@core/pages/dashboard-page';
import { SERVICES } from '@utils/services';

export const core = [
  {
    path: '',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      loadable: false
    }
  },
  {
    path: '/profile',
    component: View,
    children: [
      {
        path: '',
        name: 'core.profile',
        meta: {
          title: { code: 'core.breadcrumb.profile' }
        },
        component: () => import(/* webpackChunkName: "profile" */ '@core/pages/profile-page.vue')
      },
      {
        path: 'payments',
        name: 'core.payment.index',
        meta: {
          title: { code: 'core.breadcrumb.payment.index' }
        },
        component: () => import(/* webpackChunkName: "profile" */ '@core/pages/payments-list-page')
      },
      {
        path: 'documents',
        name: 'core.document.index',
        meta: {
          title: { code: 'core.breadcrumb.document.index' }
        },
        component: () =>
          import(/* webpackChunkName: "profile" */ '@core/pages/documents/documents-list-page')
      },
      {
        path: 'document/add',
        name: 'core.document.create',
        meta: {
          title: { code: 'core.breadcrumb.document.index' }
        },
        component: () =>
          import(/* webpackChunkName: "profile" */ '@core/pages/documents/documents-upload-page')
      },
      {
        path: '/prices',
        component: () => import(/* webpackChunkName: "prices" */ '@core/pages/prices-list-page'),
        children: [
          {
            path: '',
            redirect: { name: 'core.price.type', params: { type: SERVICES[0] } },
            name: 'core.price.index'
          },

          {
            path: `:type(${SERVICES.join('|')})`,
            name: 'core.price.type',
            component: () =>
              import(/* webpackChunkName: "prices" */ '@core/pages/prices-list-page'),
            meta: {
              title: { code: 'core.breadcrumb.price.index' }
            }
          }
        ]
      }
    ]
  }
];

export const auth = {
  path: '/auth',
  redirect: {
    name: 'auth.login'
  },
  beforeEnter: is_not_auth,
  component: () => import(/* webpackChunkName: "auth" */ '@core/layouts/auth'),
  children: [
    {
      path: '/login',
      name: 'auth.login',
      component: () => import(/* webpackChunkName: "auth" */ '@core/pages/login-page')
    },
    {
      path: '/register',
      name: 'auth.register',
      component: () => import(/* webpackChunkName: "auth" */ '@core/pages/register-page')
    },
    {
      path: '/password/reset',
      name: 'auth.reset_password',
      component: () => import(/* webpackChunkName: "auth" */ '@core/pages/reset-password-page')
    },
    {
      path: '/r/:verify_code',
      beforeEnter: (to, from, next) => {
        next({ name: 'auth.register', params: to.params });
      }
    }
  ]
};
